import React, { useCallback } from 'react';
import { mergeStyles } from '@cian/utils';

import { EPageKind } from '../../../../types/page';
import { ICard } from '../../GlamorousCards/types';
import { Card } from '../../Card';
import { Text } from '../../Text';
import { Button } from '../../Button';
import { trackCardClick } from '../../tracking/trackCardClick';

import styles from './HorizontalFullImageCard.css';

interface IProps extends ICard {
  pageKind: EPageKind;
  className?: string;
}

export const HorizontalFullImageCard = ({ pageKind, title, imageUrl, link, buttonText, className }: IProps) => {
  const { className: rootClassName } = mergeStyles(styles['card'], className);
  const trackClick = useCallback(() => trackCardClick({ pageKind, cardTitle: title }), []);

  const rootStyle = {
    backgroundImage: `url(${imageUrl})`,
  };

  return (
    <Card link={link} className={rootClassName} style={rootStyle} onClick={trackClick}>
      <Text type="h4" lineClamp={2} color="secondary" className={styles['title']}>
        {title}
      </Text>

      <Button type="secondary" className={styles['button']}>
        {buttonText || 'Интересно'}
      </Button>
    </Card>
  );
};
